import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import styles from '../NewUserWizard.module.css';

const StepDone = ({ onClose }) => {
  const { t } = useLanguage();

  const nextSteps = [
    {
      emoji: '📧',
      bg: '#fffbeb',
      title: t('step5Next1Title', 'Check your email'),
      desc: t('step5Next1Desc', 'Approve or reject AI-drafted replies directly from your inbox — no login needed.'),
    },
    {
      emoji: '📊',
      bg: '#eff8ff',
      title: t('step5Next2Title', 'Visit My Stats'),
      desc: t('step5Next2Desc', 'See all reviews, reply status, and response rate in one clean dashboard.'),
    },
    {
      emoji: '⚙️',
      bg: '#faf5ff',
      title: t('step5Next3Title', 'Adjust Settings'),
      desc: t('step5Next3Desc', 'Change your reply tone, language, signature, and business voice anytime.'),
    },
  ];

  return (
    <div>
      <div className={styles.successHero}>
        <div className={styles.successIconWrap}>
          <svg
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#059669"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="20 6 9 17 4 12" className={styles.successCheck} />
          </svg>
        </div>
        <h2 className={styles.wizardTitle} style={{ marginBottom: 8 }}>
          {t('step5Title', "You're all set! 🎉")}
        </h2>
        <p className={styles.wizardSubtitle} style={{ marginBottom: 0 }}>
          {t('step5Sub', 'Your account is ready. Reviews will start appearing once Google syncs — usually within a few hours.')}
        </p>
      </div>

      <div className={styles.nextStepsList}>
        {nextSteps.map((s, i) => (
          <div className={styles.nextStepCard} key={i}>
            <div className={styles.nextStepIconWrap} style={{ background: s.bg }}>
              {s.emoji}
            </div>
            <div>
              <div className={styles.nextStepTitle}>{s.title}</div>
              <div className={styles.nextStepDesc}>{s.desc}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          type="button"
          className={styles.btnPrimary}
          style={{ padding: '13px 36px', fontSize: '1rem' }}
          onClick={onClose}
        >
          {t('step5DashboardBtn', 'Go to Dashboard')}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StepDone;
